import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, ViewChild } from "@angular/core";
import { DialogConfig } from "../dialog/dialog-config";
import { DialogRef } from "../dialog/dialog-ref";
import { UserService } from "app/@core/data/users.service";
import { NotificationUtilService } from "app/@core/utils/notification.util.service";
import { MediaDownloadService } from "app/@core/data/media-download.service";
import { TranslateJsonService } from "app/@core/data/translate-json.service";
import { AiAlarmValidation } from "app/@core/models/aiAlarmValidation.entity";
import {DataService} from "../../../@core/data/data.service";
import {MpegtsPlayerService} from "../../../@core/utils/mpegts-player.service";

@Component({
    templateUrl: 'zoom-medias.component.html',
    styleUrls: ['zoom-medias.component.scss']
})
export class ZoomMediasComponent implements AfterViewInit, OnDestroy {
  @ViewChild('videoWrapper') public videoWrapper: ElementRef;
  @ViewChild('myImage') myImage: ElementRef<HTMLImageElement>;
    private mpegtsPlayers: any[] = [];
    public imageOpacity = 1;
    public isPicture: boolean = true;
    public urls: string[] = [];
    public plate: string;
    public prefix: string;
    public user: any = {};
    public userVideoDataEmail: string = "";
    public isDownloading: boolean = false;
    public alarmPlate: string = "";
    public alarmPrefix: string = "";
    public alarmAiEvaluationStatus: string = "";
    public aiAlarmValidations: AiAlarmValidation[] = [];
    
    constructor(
        private notificationService: NotificationUtilService,
        private translateJsonService: TranslateJsonService,
        public config: DialogConfig,
        public dialog: DialogRef,
        private userService: UserService,
        public dataService: DataService,
        private mediaDownloadService: MediaDownloadService,
        public mpegtsPlayerService: MpegtsPlayerService
    ) {
      if (!config.data.urlMovies || config.data.urlMovies.every(url => url === "")) {
            this.isPicture = true;
            this.urls = config.data.urlPictures !== undefined ? config.data.urlPictures : [];
    } else {
            this.isPicture = false;
            this.urls = config.data.urlMovies;
          }
          this.handleAiValidations(config);
          this.plate = config.data.vehicle_plates;
          this.prefix = config.data.vehicle_prefix;
          this.alarmPlate = config.data.alarm.vehicle_plates ? config.data.alarm.vehicle_plates : "";
          this.alarmPrefix = config.data.alarm.vehicle_prefix ? config.data.alarm.vehicle_prefix : "";
          this.alarmAiEvaluationStatus = config.data.alarm.aiEvaluationStatus ?  config.data.alarm.aiEvaluationStatus : "NOT_EVALUATION";
          this.urls = this.urls.filter(url => url != "");
          this.dataService = dataService;
  }

    onClose() {
        this.dialog.close('some value')
    }

    data1 = new Date();

    public userEmail(){
    }

    public isFullscreenVideo = false;

  onVideoPlay() {
    this.imageOpacity = 0;
    this.myImage.nativeElement.classList.add('hide-image');
  }

  handleDownload(plate, prefix, url) {
    if(this.isDownloading)return;
    this.isDownloading=true
    const filename = this.mediaDownloadService.extractFileNameFromUrl(url);
    this.mediaDownloadService.downloadFile(this.mediaDownloadService.buildVideoTelemetryWatermarkBody(plate, prefix, url)).subscribe(blob => {
      this.mediaDownloadService.saveFileLocally(blob, filename);
      this.isDownloading = false;
    }, err=>{
      if (err.status === 503) {
        this.notificationService.printErrorMessage(this.translateJsonService.getTranslateSubs("GLOBAL.service_unavailable"))
      } else {
        this.notificationService.printErrorMessage(this.translateJsonService.getTranslateSubs("GLOBAL.failed_operation"))
      }
      this.isDownloading = false;
    });
  }
  
  onVideoPause() {
    this.imageOpacity = 1;
    this.myImage.nativeElement.classList.remove('hide-image');
  }
  
    @HostListener('fullscreenchange', ['$event'])
    @HostListener('webkitfullscreenchange', ['$event'])
    @HostListener('mozfullscreenchange', ['$event'])
    @HostListener('MSFullscreenChange', ['$event'])
    @HostListener('fullscreenchange', ['$event'])
  
    onFullScreenChange($event) {
      if(document.fullscreenElement) {
        if(this.videoWrapper.nativeElement.getAttribute('data-wrapper-type') === 'video-wrapper') {
          this.isFullscreenVideo = true;
          
        }
      }else {
        if(this.isFullscreenVideo === true) {
          this.isFullscreenVideo = false;
        }
      }
    }
    
    
    public toggleFullscreen($event: MouseEvent) {
      if ($event.target instanceof Element) {
        const target = ($event.target as Element);
        const zoomElement = target.closest('.video-wrapper');
        if (!document.fullscreenElement) {  
          zoomElement.requestFullscreen();
          
        } else if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    }
    
    public handleAiValidations(config: any) {
      if (config.data.aiAlarmValidations && config.data.aiAlarmValidations.length > 0) {
        
        config.data.aiAlarmValidations.forEach(validation => {
          if (validation.alarmId === config.data.alarm.id) {
            this.aiAlarmValidations.push(validation);
          }
        });
      }
    }

    getValidationsForIndex(index: number): AiAlarmValidation[] {
      return this.aiAlarmValidations.filter(validation => validation.channel === index);
    }

    ngAfterViewInit() {
      if (this.isPicture) return;
      setTimeout(() => {
        this.mpegtsPlayers = this.mpegtsPlayerService.createPlayers(this.urls, 'zoom-video-');
      });
    }

    ngOnDestroy() {
      this.mpegtsPlayerService.destroyPlayers(this.mpegtsPlayers);
      this.mpegtsPlayers = [];
    }
}
